"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = void 0;
const RuleSetFactory_1 = require("./RuleSetFactory");
class Validator {
    constructor(config) {
        this.ruleSets = config.ruleSets.map((ruleSetConfig) => {
            return RuleSetFactory_1.RuleSetFactory.create(ruleSetConfig);
        });
    }
    validate(data, multi = false) {
        const result = {
            valid: true,
            details: [],
            isValid: (path) => {
                const evRes = result.details.find(res => res.field === path);
                return !evRes || evRes.valid;
            },
            getEvaluationResult: (path) => result.details.find(res => res.field === path),
        };
        for (let i = 0; i < this.ruleSets.length; i++) {
            const ruleSet = this.ruleSets[i];
            if (ruleSet.shouldEvaluate(data)) {
                const res = this.ruleSets[i].evaluate('', data, multi);
                if (!res.valid) {
                    if (multi) {
                        result.valid = false;
                        result.details = result.details || [];
                        result.details = result.details.concat(res.details);
                    }
                    else {
                        return res;
                    }
                }
            }
        }
        if (!multi) {
            delete result.details;
        }
        return result;
    }
}
exports.Validator = Validator;
//# sourceMappingURL=Validator.js.map